import * as actionType from "./NewHostOnboardingActionType";

export const newHostOnboardingReducer = (
    state = {
        onboardingData: {
            fetching: false,
            error: { status: false, message: '',errorCode:'',errorData:''},
            data: [],
        },

        countryListDetails:{
            countryList: [],
        },
    },
        action
)=>{
    switch (action.type) {
        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA:
            return{
                ...state,
                onboardingData:{
                ...state.onboardingData,
                fetching: true,
                error : {state : false, message: ''}
                }
            };
        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA_SUCCESS:
            return {
                ...state,
                onboardingData:{
                    ...state.onboardingData,
                    fetching: false,
                    error : {state : false, message: ''},
                    data: action.payload
                }
            };
        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA_FAILS:
            return {
                ...state,
                onboardingData:{
                    ...state.onboardingData,
                    fetching: false,
                    error : {state : true, message: action.payload},
                }
            };
        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID:
            return {
                ...state,
                hostOnboardingDetailsById: {
                    ...state.hostOnboardingDetailsById,
                    fetching: true,
                    error: { status: false, message: '' }
                }
            };

        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_SUCCESS:
            return {
                ...state,
                hostOnboardingDetailsById: {
                    ...state.hostOnboardingDetailsById,
                    fetching: false,
                    error: { status: false, message: '' },
                    data: action.payload
                }
            };

        case actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_FAILS:
            return {
                ...state,
                hostOnboardingDetailsById: {
                    ...state.hostOnboardingDetailsById,
                    fetching: false,
                    error: { status: true, message: action.payload }
                }
            };
        case actionType.COUNTRY_CODE_SUBMIT_SUCCESS:
            return{
                ...state,
                countryListDetails:{
                    ...state.countryList,
                    countryList: action.payload,
                }
            };
        default:
            return state;
    }
}